const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
  SET_DATA: 'menu/SET_DATA',
}

export default actions
